import React from 'react';
import errorBoundary from '@ifeng/errorBoundary';
import PropTypes from 'prop-types';
import styles from './index.css';
import classNames from '../classnames/bind';
import { debounce } from 'lodash';
const { callApp, getSchemeLink, getWebAppLink } = require('@ifeng/callapp');
const cx = classNames.bind(styles);

const TempleteFooter = ({
    giveLikeHandle,
    commentHandle,
    shareHandle,
    dataInfo,
    commentInfo = {},
    likeInfo = {},
    forward = false,
}) => {
    /**
     * userLikeCount: >0 表示该用户点赞，<=0表示未点赞
     * likeCount 真实点赞数
     * fictitiousLikeCount 虚假点赞数
     */
    const { likeCount = 0, userLikeCount = 0 } = likeInfo|| {};
    // 当前用户已点赞 标识
    const currentUserLiked = userLikeCount > 0;

    const formatCount = count => {
        if (count > 99999999) {
            return `${(count / 100000000).toFixed(1)}亿`;
        } else if (count > 9999) {
            return Number((count / 10000).toFixed(1)) === 10000 ? '9999.9万' : `${(count / 10000).toFixed(1)}万`;
        } else {
            return count;
        }
    };
    let clickCallApp = () => {
        callApp({
            client:"newsApp",
            docType: "web",
            pid: `http://test0.web-pages-channel.shank.ifeng.com/mobile/news/circles/contentDetail?id=${dataInfo.id}`,
            kind: '',
        });
    }
    return (
        <div onClick={clickCallApp}>
            <div className={cx('templete_footer', { forward })}>
                <div className={styles.item_cell} >
                    <span className={cx('icon', { zan: !currentUserLiked, zaned: currentUserLiked })} />
                    <span className={cx('zan', { zan_text: !currentUserLiked, zaned_text: currentUserLiked })}>
                    {likeCount > 0 ? formatCount(likeCount) : '赞'}
                </span>
                </div>
                <div className={styles.item_cell}>
                    <span className={cx('icon', 'comment')} />
                    <span>{commentInfo?.num > 0 ? formatCount(commentInfo?.num) : '评论'}</span>
                </div>
                <div className={styles.item_cell}>
                    <span className={cx('icon', 'share')} />
                    <span>分享</span>
                </div>
            </div>
        </div>

    );
};

TempleteFooter.propTypes = {
    giveLikeHandle: PropTypes.func,
    commentHandle: PropTypes.func,
    shareHandle: PropTypes.func,
    commentInfo: PropTypes.object,
    likeInfo: PropTypes.object,
    /**
     * 转发
     */
    forward: PropTypes.bool,
};

export default errorBoundary(TempleteFooter);
